export const URL_BIBLE = process.env.NEXT_PUBLIC_BIBLE_CLOUDFRONT_URL ?? "";
